import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import { Form, OriCheckbox, OriNumberInput } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/DiscountLastExpression';
import ProductsApplyToRadioAndTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductsApplyToRadioAndTable';
import { maxMoney, maxTimes } from 'src/tools/constant';
import { isNumber } from 'src/tools/helper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { last2Precision } from 'src/tools/regExp';
import css from './css.module.less';
const Item = Form.Item;
const _base = 'applyTo';
const _discountValue = ['discountMethod', 'deduction'];
const _discountApplyToEntireOrder = 'toEntireOrder';
const _discountApplyTo = 'conditionType';
const _products = 'products';
const _discountCumulatively = 'cumulative';
const _enabledMaxAmount = 'maxTimesEnabled';
const _maxAmount = 'maxTimes';

const FixedReductionAmount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency = 'HKD', disableEdit } = props;
  return (
    <SectionWrapper
      title={getI18n('salesChannelDirectDiscount.discountValue.discountValue')}>
      <Section bottomBorder className={css.innerSection}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={getI18n(
                    'salesChannelDirectDiscount.discountValue.discountValue',
                  )}>
                  <Item
                    name={_discountValue}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.discountValue.reasonablePrice',
                                ),
                              ),
                            );
                          }
                          if (value <= 0) {
                            return Promise.reject(
                              new Error(
                                replaceI18nVariables(
                                  getI18n('general.valueshouldbegreaterthan'),
                                  0,
                                ),
                              ),
                            );
                          }
                          if (value > maxMoney) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.discountValue.reasonablePrice',
                                ),
                              ),
                            );
                          }

                          if (!last2Precision.test(value)) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'salesChannelDirectDiscount.discountValue.twoDecimal',
                                ),
                              ),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      max={maxMoney}
                      size='large'
                      suffix={currency || 'HKD'}
                      disabled={disableEdit}
                    />
                  </Item>
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item
          name={[_base, _discountApplyToEntireOrder]}
          valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValuereduction.entireOrder',
            )}
          </OriCheckbox>
        </Item>
        <div className={css.entireTip}>
          {getI18n(
            'salesChannelDirectDiscount.discountValuereduction.entireOrderTips',
          )}
        </div>
      </Section>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, [_base, _discountApplyToEntireOrder]);
          const cV = get(c, [_base, _discountApplyToEntireOrder]);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const isDisplay = !getFieldValue([
            _base,
            _discountApplyToEntireOrder,
          ]);
          if (isDisplay) {
            return (
              <Section bottomBorder className={css.productSection}>
                <ProductsApplyToRadioAndTable
                  radioName={[_base, _discountApplyTo]}
                  tableName={[_base, _products]}
                  tableId={'SalesChannelDirectDiscountFixedReductionAmount'}
                  disableEdit={disableEdit}
                />
              </Section>
            );
          }
          return null;
        }}
      </Item>
      <Section bottomBorder className={css.generalSection}>
        <Item name={[_base, 'flashSaleExcluded']} valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValue.excludeflashsaleitems',
            )}
          </OriCheckbox>
        </Item>
      </Section>
      <Section bottomBorder className={css.generalSection}>
        <Item name={[_base, _discountCumulatively]} valuePropName={'checked'}>
          <OriCheckbox disabled={disableEdit}>
            {getI18n(
              'salesChannelDirectDiscount.discountValuereduction.applydiscountcumulatively',
            )}
          </OriCheckbox>
        </Item>
        <Item
          shouldUpdate={(p, c) => {
            const pV = get(p, [_base, _discountCumulatively]);
            const cV = get(c, [_base, _discountCumulatively]);
            const pE = get(p, [_base, _discountApplyToEntireOrder]);
            const cE = get(c, [_base, _discountApplyToEntireOrder]);
            return pV !== cV || pE !== cE;
          }}>
          {({ getFieldValue }) => {
            const entireHasChecked = getFieldValue([
              _base,
              _discountApplyToEntireOrder,
            ]);
            const cumulativeHasChecked = getFieldValue([
              _base,
              _discountCumulatively,
            ]);
            const isDisplay =
              !entireHasChecked || (entireHasChecked && cumulativeHasChecked);
            if (isDisplay) {
              return (
                <div className={css.maxContainer}>
                  <Item
                    name={[_base, _enabledMaxAmount]}
                    valuePropName={'checked'}>
                    <OriCheckbox disabled={disableEdit}>
                      {getI18n(
                        'salesChannelDirectDiscount.discountValuereduction.maximumnumber',
                      )}
                    </OriCheckbox>
                  </Item>
                  <Item
                    shouldUpdate={(p, c) => {
                      const pV = get(p, [_base, _enabledMaxAmount]);
                      const cV = get(c, [_base, _enabledMaxAmount]);
                      return pV !== cV;
                    }}>
                    {({ getFieldValue }) => {
                      const checked = getFieldValue([_base, _enabledMaxAmount]);
                      if (checked) {
                        return (
                          <div className={css.maxInputContainer}>
                            <Item
                              name={[_base, _maxAmount]}
                              rules={[
                                {
                                  validator: async (x, value) => {
                                    if (!isNumber(value)) {
                                      return Promise.reject(
                                        new Error(
                                          getI18n(
                                            'salesChannelDirectDiscount.discountValue.reasonablePrice',
                                          ),
                                        ),
                                      );
                                    }
                                    if (value < 1) {
                                      return Promise.reject(
                                        new Error(
                                          `${getI18n('general.noLessThan')} 1`,
                                        ),
                                      );
                                    }
                                    if (value > maxTimes) {
                                      return Promise.reject(
                                        new Error(
                                          getI18n(
                                            'salesChannelDirectDiscount.discountValue.reasonablePrice',
                                          ),
                                        ),
                                      );
                                    }
                                  },
                                },
                              ]}>
                              <OriNumberInput
                                size='large'
                                max={maxTimes}
                                precision={0}
                                disabled={disableEdit}
                              />
                            </Item>
                          </div>
                        );
                      }
                      return null;
                    }}
                  </Item>
                </div>
              );
            }
            return null;
          }}
        </Item>
      </Section>
      <Tip
        title={getI18n(
          'salesChannelDirectDiscount.discountValue.discountCalculationrule',
        )}
        content={getI18n(
          'salesChannelDirectDiscount.discountValuereduction.cumulativelyReduction',
        )}
      />
    </SectionWrapper>
  );
};
export default FixedReductionAmount;
